import React, { MouseEventHandler } from 'react';
import { create } from 'zustand';

interface ZoneMenuItem {
  title: string;
  subTitle?: string;
  icon: React.ReactNode;
  disabled: boolean;
  isActive: boolean;
  isVisible: boolean;
  path?: string;
  onClick?: MouseEventHandler<any>;
}

interface SmartZoneMenuItem extends ZoneMenuItem { }
interface SatV1ZoneMenuItem extends ZoneMenuItem { }
interface SatV2ZoneMenuItem extends ZoneMenuItem { }
interface SatV3ZoneMenuItem extends ZoneMenuItem { }
interface SatV4ZoneMenuItem extends ZoneMenuItem { }
interface SatV5ZoneMenuItem extends ZoneMenuItem { }
interface ContentZoneMenuItem extends ZoneMenuItem { }
interface WorkflowZoneMenuItem extends ZoneMenuItem { }
interface CommunicationZoneMenuItem extends ZoneMenuItem { }
interface ManagementInformationZoneMenuItem extends ZoneMenuItem { }
interface SchoolZoneMenuItem extends ZoneMenuItem {
  popupItems?: {
    title: string;
    path: string;
    icon: React.ReactNode;
  }[];
}
interface TimeTableZoneMenuItem extends ZoneMenuItem { }
interface ChallengeZoneMenuItem extends ZoneMenuItem { }
interface ContactZoneMenuItem extends ZoneMenuItem { }
interface CommsZoneMenuItem extends ZoneMenuItem { }

interface ZoneMenuState {
  schoolZone?: SchoolZoneMenuItem;
  satV1Zone?: SatV1ZoneMenuItem;
  satV2Zone?: SatV2ZoneMenuItem;
  satV3Zone?: SatV3ZoneMenuItem;
  satV4Zone?: SatV4ZoneMenuItem;
  satV5Zone?: SatV5ZoneMenuItem;
  contentZone?: ContentZoneMenuItem;
  communicationZone?: CommunicationZoneMenuItem;
  managementInformationZone?: ManagementInformationZoneMenuItem;
  workflowZone?: WorkflowZoneMenuItem;
  smartZone?: SmartZoneMenuItem;
  timeTableZone?: TimeTableZoneMenuItem;
  challengeZone?: ChallengeZoneMenuItem;
  contactZone?: ContactZoneMenuItem;
  commsZone?: CommsZoneMenuItem;
}

interface ZoneMenuHandlers {
  setSchoolZone: (schoolZone: Partial<SchoolZoneMenuItem>) => void;
  setSatV1Zone: (satV1Zone: Partial<SatV1ZoneMenuItem>) => void;
  setSatV2Zone: (satV2Zone: Partial<SatV2ZoneMenuItem>) => void;
  setSatV3Zone: (satV3Zone: Partial<SatV3ZoneMenuItem>) => void;
  setSatV4Zone: (satV4Zone: Partial<SatV4ZoneMenuItem>) => void;
  setSatV5Zone: (satV5Zone: Partial<SatV5ZoneMenuItem>) => void;
  setContentZone: (contentZone: Partial<ContentZoneMenuItem>) => void;
  setCommunicationZone: (communicationZone: Partial<CommunicationZoneMenuItem>) => void;
  setManagementInformationZone: (managementInformationZone: Partial<ManagementInformationZoneMenuItem>) => void;
  setWorkflowZone: (workflowZone: Partial<WorkflowZoneMenuItem>) => void;
  setSmartZone: (smartZone: Partial<SmartZoneMenuItem>) => void;
  setTimeTableZone: (timeTableZone: Partial<TimeTableZoneMenuItem>) => void;
  setContactZone: (contactZone: Partial<ContactZoneMenuItem>) => void;
  setCommsZone: (commsZone: Partial<CommsZoneMenuItem>) => void;
  setZoneMenu: (zoneMenu: Partial<ZoneMenuState>) => void;
  setChallengeZone: (challengeZone: Partial<ChallengeZoneMenuItem>) => void;
}

export interface ZoneStore extends ZoneMenuHandlers, ZoneMenuState { }

export const useZoneStore = create<ZoneStore>()((set) => ({
  setSchoolZone: (schoolZone) => set((prev) => ({ ...prev, schoolZone: { ...prev.schoolZone, ...schoolZone } })),
  setContentZone: (contentZone) => set((prev) => ({ ...prev, contentZone: { ...prev.contentZone, ...contentZone } })),
  setCommunicationZone: (communicationZone) =>
    set((prev) => ({ ...prev, communicationZone: { ...prev.communicationZone, ...communicationZone } })),
  setManagementInformationZone: (managementInformationZone) =>
    set((prev) => ({
      ...prev,
      managementInformationZone: { ...prev.managementInformationZone, ...managementInformationZone },
    })),
  setWorkflowZone: (workflowZone) =>
    set((prev) => ({ ...prev, workflowZone: { ...prev.workflowZone, ...workflowZone } })),
  setSmartZone: (smartZone) => set((prev) => ({ ...prev, smartZone: { ...prev.smartZone, ...smartZone } })),
  setTimeTableZone: (timeTableZone) =>
    set((prev) => ({ ...prev, timeTableZone: { ...prev.timeTableZone, ...timeTableZone } })),
  setChallengeZone: (challengeZone) =>
    set((prev) => ({ ...prev, challengeZone: { ...prev.challengeZone, ...challengeZone } })),
  setContactZone: (contactZone) => set((prev) => ({ ...prev, contactZone: { ...prev.contactZone, ...contactZone } })),
  setCommsZone: (commsZone) => set((prev) => ({ ...prev, commsZone: { ...prev.commsZone, ...commsZone } })),
  setZoneMenu: (zoneMenu) => set((prev) => ({ ...prev, ...zoneMenu })),
  setSatV1Zone: (satV1Zone) => set((prev) => ({ ...prev, satV1Zone: { ...prev.satV1Zone, ...satV1Zone } })),
  setSatV2Zone: (satV2Zone) => set((prev) => ({ ...prev, satV2Zone: { ...prev.satV2Zone, ...satV2Zone } })),
  setSatV3Zone: (satV3Zone) => set((prev) => ({ ...prev, satV3Zone: { ...prev.satV3Zone, ...satV3Zone } })),
  setSatV4Zone: (satV4Zone) => set((prev) => ({ ...prev, satV4Zone: { ...prev.satV4Zone, ...satV4Zone } })),
  setSatV5Zone: (satV5Zone) => set((prev) => ({ ...prev, satV5Zone: { ...prev.satV5Zone, ...satV5Zone } })),
}));
